import axios from 'axios'
import QS from 'qs'
import IP from './ip'
import { Loading } from 'element-ui'

let loadingInstance

axios.defaults.baseURL = IP.Ip
// 设置超时时间
axios.defaults.timeout = 45000
// post 请求头
// axios.defaults.headers.post['Content-type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
// 请求拦截
axios.interceptors.request.use(
  (config) => {
    loadingInstance = Loading.service({
      fullscreen: true,
      text: '加载中...',
      background: 'rgba(0, 0, 0, .1)'
    })
    if (config.url.endsWith('/login') == false) {
      if (axios.defaults.baseURL === config.baseURL) {
        const token = localStorage.getItem('token')
        if (token) {
          config.headers['token'] = token
        }
      }
    }

    // if (token && (config.headers.Autorization === token)) {
    if (config.method === 'post') {
      if (axios.defaults.baseURL === config.baseURL) {
        config.data = QS.stringify(config.data)
      } else {
        config.data = QS.stringify(config.data)
      }
    }
    // if (config.url.endsWith('/medium/read') || config.url.endsWith('/medium/cancel')) {
    //   config.baseURL = IP.MediumIp
    // }

    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)
// 响应拦截
axios.interceptors.response.use(
  (response) => {
    loadingInstance.close()
    return Promise.resolve(response)
  },
  (error) => {
    loadingInstance.close()
    return Promise.reject(error)
  }
)
export default axios
